import Logo from '@assets/svg/logo.svg';
import styled from '@emotion/styled';
import {col, fontWeight, mq} from '@styles/helpers';
import {colors} from '@styles/colors';
import OvalButton from '@components/Buttons/OvalButton';
import {absoluteCenter} from '@styles/reusable';
import {Devices} from '@styles/tokens';

export const AttenderLogo = styled(Logo)<{mobile?:boolean}>`
  margin: 0 auto;
  width: ${props => props.mobile?"80vw":col(8, 12)};
  max-width: 500px;
  height: auto;
`;

export const ButtonRow = styled.div<{mobile?:boolean}>`
  display: flex;
  justify-content: center;
  padding-top: ${props => props.mobile?"40px":"20px"};
  > button {
    margin: 20px;
  }

  ${mq(Devices.tablet)} {
    flex-direction: column;

    > button {
      margin: 20px 20px 0 20px;
    }
  }
`;

export const ErrorContainer = styled.div<{height?: boolean}>`
  display: grid;
  place-content: center;
  text-align: center;
  width: 100%;
  height: ${props => props.height?"calc(80vh - 56px);":"calc(100vh - 56px);"};
  position: relative;
`;

export const Error = styled.h3`
  font-size: 24px;
  color: ${colors.mainTextColor};
  margin-top: 20px;

  ${mq(Devices.laptop)} {
    font-size: 24px;
  }

  ${mq(Devices.tablet)} {
    font-size: 16px;
  } ;
`;

export const Text = styled.p<{textColor?:boolean}>`
  font-size: 42px;
  font-weight: ${fontWeight.bold};
  line-height: 1;
  color: ${props => props? "#4d4d4d" : colors.red};
  margin-top: 30px;
  padding: 0 5%;

  ${mq(Devices.laptop)} {
    margin-top: 15px;
    font-size: 36px;
  }

  ${mq(Devices.tablet)} {
    font-size: 5vw;
  }
  ${mq(Devices.mobile)} {
    font-size: 7vw;
  } ;
`;

export const Description = styled.span`
  font-size: 22px;
  color: ${colors.gray};
  margin: 40px 0 0 0;
  max-width: 800px;
`;

export const HomeButton = styled(OvalButton)`
  margin: 20px auto 0;
  font-size: 18px;
`;


export const CustomButton = styled.a<{ small: boolean; theme?: any, mobile?:boolean }>`
  min-height: ${(props) => (props.small ? 25 : 44)}px;
  display: grid;
  place-content: center;
  padding: ${(props) => (props.small ? '10px 25px' : '10px 5vw')};
  background-color: ${colors.mainTextColor};
  border-radius:  ${props => props.mobile?"6px":"30px"};
  box-shadow: 0px 3px 6px #00000029;
  font-size: ${(props) => (props.small ? '18px' : '18px')};
  font-weight: ${fontWeight.semiBold};
  color: ${colors.white};
  margin: 20px;
`;

export const CenterDiv = styled.div`
  position: relative;
  padding-top:50px;
  height:50vh;
  max-width: 100vw;
 
  > svg{
    height:60%;
    position: absolute;
    bottom:0;
    left:50%;
    transform: translateX(-50%);
  }

  ${mq(Devices.laptop)} {
    display:flex;
    flex-direction: column;
    align-items: center;
    height:80%;

    > svg{
      height:100%;
      max-height: 250px;
    }
  }
  
`;

export const LottieWrapper = styled.div`
  height:40vh;
  aspect-ratio: 1 / 1;
  position: absolute;
  bottom:0;
  left:50%;
  transform: translateX(-50%);

  > div{
    height:100%;
    pointer-events: none;
  }

  ${mq(Devices.laptop)} {
    height:40vh;
    position: unset;
    bottom:unset;
    left:unset;
    transform: unset;
  }
`;


export const TextMarvin = styled.h1<{red?:boolean}>`
  color: ${props => props.red?colors.red:colors.darkenedBlue};
  font-weight: ${fontWeight.bold};
  font-size: 24px;
  line-height: 1.1;
  text-align: center;

  ${mq(Devices.laptop)} {
    font-size: 20px;
  }

  ${mq(Devices.tablet)} {
    font-size: clamp(18px, 4vw, 20px);
  }
`;

export const TextBubble = styled.div`
  position: absolute;
  max-width:500px;
  width:90vw;
  bottom:89%;
  left:60%;
  padding:20px ;
  background:#fff;
  border-radius:20px;
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  

  svg:nth-of-type(1){
    height:100px;
    position: absolute;
    top:99%;
    left:70px;
    filter: drop-shadow(0px 3px 2px rgb(0 0 0 / 0.2));
  }
  
  svg:nth-of-type(2){
    display:none;
  }

  ${mq(Devices.laptop)} {
    position: relative;
    bottom:unset;
    left:unset;
    margin-bottom: 70px;

    svg:nth-of-type(1){
      display:none;
    }

    svg:nth-of-type(2){
      display: unset;
      height:100px;
      position: absolute;
      top:99%;
      right:30%;
      filter: drop-shadow(0px 4px 2px rgb(0 0 0 / 0.2));
    }
  }

`;